import * as React from 'react';
import '../css/banner-media.sass';
import ImageDescription from './ImageDescription';

export interface BannerMediaOptions {
  imageSrc?: string;
  title?: string;
  channelTitle?: string;
  channelImg?: string;
  time?: string;
  description?: string;
  theme?: 'night' | 'day';
  isVideo?: boolean;
  videoSrc?: string;
  controls?: boolean;
  autoPlay?: boolean;
  muted?: boolean;
  loop?: boolean;
  type?: string;
}

export default function BannerMedia(props: BannerMediaOptions) {
  const {
    theme = 'day',
    title,
    channelTitle,
    channelImg,
    time,
    description,
    isVideo = false,
    videoSrc,
    controls = false,
    autoPlay = false,
    muted = false,
    loop = false,
    type = 'video/mp4'
  } = props;

  return (
    <div className="banner-media">
      {!isVideo && <img alt={props.title} src={props.imageSrc} />}
      {isVideo && (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video
          autoPlay={autoPlay}
          muted={muted}
          loop={loop}
          controls={controls}
        >
          <source src={videoSrc} type={type} />
        </video>
      )}
      {title && channelTitle && channelImg && time && description && (
        <ImageDescription
          showName={title}
          pkgName={channelTitle}
          pkgImgUrl={channelImg}
          showTiming={time}
          description={description}
          theme={theme}
        />
      )}
    </div>
  );
}
